import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '#environments/environment';

// TA Pro opens the compliance report in a new tab and hands off the signed-in
// user's access token via the URL fragment (#access_token=...). Consume it before
// Angular bootstraps so the route guard sees an authenticated session and the user
// is not forced through a second login. Immediately strip the token from the URL
// (history.replaceState) so the bearer token never lingers in the address bar,
// referrer headers or the browser history stack.
function consumeTaproHandoffToken(): void {
  try {
    const fragment = window.location.hash.replace(/^#/, '');
    if (!fragment) {
      return;
    }
    const token = new URLSearchParams(fragment).get('access_token');
    if (!token) {
      return;
    }
    sessionStorage.setItem('Token', token);
    const cleanUrl = window.location.pathname + window.location.search;
    history.replaceState(null, document.title, cleanUrl);
  } catch {
    // window/URL/storage not available (e.g. SSR) - ignore.
  }
}

consumeTaproHandoffToken();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
